// extracted by mini-css-extract-plugin
module.exports =  {"default":"_93444fe79c--default--t0tX7","light":"_93444fe79c--light--s9E4P","outline":"_93444fe79c--outline--osTFY"};